module.exports = __webpack_public_path__ + "img/big4-1.3c35fadc.jpg";